import React, { lazy, Suspense, memo } from 'react';
import PublicLayout from '../components/layouts/PublicLayout';

// Lazy load components for code splitting
const HeroBanner = lazy(() => import('../components/public/HeroBanner'));
const HowItWorks = lazy(() => import('../components/public/HowItWorks'));
const KeyFeatures = lazy(() => import('../components/public/KeyFeatures'));
const BenefitsByUserType = lazy(() => import('../components/public/BenefitsByUserType'));
const ExploreBanner = lazy(() => import('../components/public/ExploreBanner'));
const OrganizerCTA = lazy(() => import('../components/public/OrganizerCTA'));
const FAQ = lazy(() => import('../components/public/FAQ'));

// Loading fallback component
const SectionLoader = () => (
    <div className="w-full py-16 flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
    </div>
);

const HomePage = () => {
    // Define sections for navigation (memoized to prevent re-creation)
    const sections = React.useMemo(() => [
        { id: 'how-it-works', label: 'How It Works' },
        { id: 'key-features', label: 'Features' },
        { id: 'benefits-by-user-type', label: 'Benefits' },
        { id: 'explore-banner', label: 'Explore' },
        { id: 'organizer-cta', label: 'For Organizers' },
        { id: 'faq', label: 'FAQ' }
    ], []);

    return (
        <PublicLayout sections={sections}>
            <Suspense fallback={<SectionLoader />}>
                <HeroBanner />
            </Suspense>

            <Suspense fallback={<SectionLoader />}>
                <HowItWorks />
            </Suspense>

            <Suspense fallback={<SectionLoader />}>
                <KeyFeatures />
            </Suspense>

            <Suspense fallback={<SectionLoader />}>
                <BenefitsByUserType />
            </Suspense>

            <Suspense fallback={<SectionLoader />}>
                <ExploreBanner />
            </Suspense>

            <Suspense fallback={<SectionLoader />}>
                <OrganizerCTA />
            </Suspense>

            <Suspense fallback={<SectionLoader />}>
                <FAQ />
            </Suspense>
        </PublicLayout>
    );
};

export default memo(HomePage);